var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEaerLarge = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 63 58",
    style: {
      enableBackground: "new 0 0 63 58"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F47847;}\n\t.st1{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63,0v58H0V0H63z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55.2,45.9L34.6,10.3c-1-1.7-3.2-2.3-4.9-1.3c-0.6,0.3-1,0.8-1.3,1.3L7.8,45.9c-0.7,1.1-0.3,2.6,0.9,3.3 c0.4,0.2,0.8,0.3,1.2,0.3h43.2c1.3,0,2.4-1.1,2.4-2.4C55.5,46.7,55.4,46.3,55.2,45.9z M31.5,42.5c-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2 s2,0.9,2,2C33.5,41.6,32.6,42.5,31.5,42.5z M33.5,33.5c0,1.1-0.9,2-2,2s-2-0.9-2-2v-11c0-1.1,0.9-2,2-2s2,0.9,2,2V33.5z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEaerLarge);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/EAER-large.640831b93da2cb8dbc3195bdb2d70a7b.svg";